document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#form');

  if (form) {
  }
});
